import Homepage from './Homepage.vue';
export default Homepage;


// WEBPACK FOOTER //
// ./src/components/parts/slider/homepage/index.ts